import { Timestamp } from "firebase/firestore";

import { FirebaseData } from "../../General/FirebaseData";
import { UserData } from "../UserData";
import { t } from "i18next";
import { eventBus } from "@src/utils/eventBus";
import { EventBusKey } from "@src/utils/eventBusEnum";

export class NotificationData extends FirebaseData {
  static types = {
    UNDEFINED: 0,
    NEW_DEVIATION: 1,
    DEVIATION_ACTIVITY: 2,
    NEW_CHAT: 3,
    CHAT_MESSAGE: 4,
    TASK_ACTIVITY: 5,
    DEVIATION_REMINDER: 6,
    NEW_EVENT_ATTENDEE: 7,
    NEW_POST: 8,
    ACTIVITY: 9,
    GENERAL_LINK: 10,
  };
  sendDate?: Date;
  type: number = NotificationData.types.UNDEFINED;
  read?: boolean;

  //Private fields
  _userForImageView: UserData | undefined = undefined;
  _title: string = t("main.noTitle");
  _body: string = t("main.noDataToDisplay");
  _redirectPath: string = "/";

  setup(data: any) {
    this.sendDate = data.sendDate instanceof Timestamp ? data.sendDate.toDate() : undefined;
    this.type = typeof data.type === "number" ? data.type : 0;
    this.read = Boolean(data.read);

    if (typeof data.notificationData === "object") {
      if (typeof data.notificationData.title === "string") this._title = data.notificationData.title;
      if (typeof data.notificationData.body === "string") this._body = data.notificationData.body;
    }

    super.setup(data);
  }

  dismiss() {
    if (!this.read) {
      this.saveUpdate({ read: true }).then(() => {
        eventBus.publish(EventBusKey.UpdateNotification, new Date().toISOString());
      });
    }
  }

  /** Set/get the redirect path */
  set redirectPath(path: string) {
    this._redirectPath = path;
  }
  get redirectPath(): string {
    return this._redirectPath;
  }

  /** Set/get title of notification */
  set title(title: string) {
    this._title = title;
  }
  get title(): string {
    return this._title;
  }

  /** Set/get text body of notification */
  set body(body: string) {
    this._body = body;
  }
  get body(): string {
    return this._body;
  }

  /** Set/get data of the user that authored the notification */
  set userForImageView(user: UserData | undefined) {
    this._userForImageView = user;
  }
  get userForImageView(): UserData | undefined {
    if (!this._userForImageView) return undefined;
    if (this._userForImageView.deleted) return undefined;
    if (!this._userForImageView.loaded) this._userForImageView.loadWithCompletionHandler((e) => {});

    return this._userForImageView;
  }
}
